import React from "react";
import StyledCardContent from "./CardContent.styled";
import { ICardContent } from "./CardContent.interface";

const CardContent = (props: ICardContent) => <StyledCardContent {...props} />;

export default CardContent;
